import { type CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

import { Icon } from "../icons/icon";
import { cn } from "../../lib/utils";

type SonnerStyle = CSSProperties & Record<`--${string}`, string>;

const defaultStyle: SonnerStyle = {
  "--normal-bg": "var(--popover)",
  "--normal-text": "var(--popover-foreground)",
  "--normal-border": "var(--border)",
  "--border-radius": "var(--radius)",
};

function Toaster({
  className,
  icons,
  style,
  theme: _theme,
  toastOptions,
  ...props
}: ToasterProps) {
  return (
    <Sonner
      data-slot="toaster"
      theme="light"
      className={cn("toaster group", className)}
      icons={{
        success: <Icon src="CircleCheck" className="size-4" />,
        info: <Icon src="Info" className="size-4" />,
        warning: <Icon src="TriangleAlert" className="size-4" />,
        error: <Icon src="OctagonX" className="size-4" />,
        loading: <Icon src="LoaderCircle" className="size-4 animate-spin" />,
        ...icons,
      }}
      style={{ ...defaultStyle, ...style }}
      toastOptions={{
        ...toastOptions,
        classNames: {
          ...toastOptions?.classNames,
          actionButton: cn(
            "bg-primary text-primary-foreground",
            toastOptions?.classNames?.actionButton,
          ),
          cancelButton: cn(
            "bg-secondary text-secondary-foreground",
            toastOptions?.classNames?.cancelButton,
          ),
          closeButton: cn(
            "!border-border !bg-popover !text-popover-foreground",
            "hover:!border-border hover:!bg-accent hover:!text-accent-foreground",
            toastOptions?.classNames?.closeButton,
          ),
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
